import { atom } from 'jotai';
import { getMapDefaultConfig } from 'components/map/atoms';
import type { MapUserConfig, MapUserConfigAtom } from 'components/map/types';
import { atomWithStorage } from 'jotai/utils';
import { DETAIL_CARDS } from './detail/section-cards';

// Client-side UI state for the Well Workspace feature. Server state lives in React
// Query — see `hooks.ts` for the reads and writes, `api.ts` for the requests, and
// `query-keys.ts` for the cache keys.

/**
 * Which section cards are visible (Layout settings) — every Story-2 section on by
 * default.
 *
 * Persisted per Story 2: the choice describes how this reader wants the workspace laid
 * out, not the workspace, so it is kept per browser rather than per workspace. A
 * missing or corrupt key falls back to the default above.
 */
export const visibleCardsAtom = atomWithStorage<Record<string, boolean>>(
  'well-workspace-visible-cards',
  Object.fromEntries(DETAIL_CARDS.map((card) => [card.id, true])),
  undefined,
  { getOnInit: true }
);

/**
 * Everything off. This is a picker for the sticks the reader has chosen — wells, units,
 * basins and title assets would only be noise over a handful of laterals, and the ambient
 * layers would make the endpoint markers hard to hit.
 */
const baseMapConfig = getMapDefaultConfig();
export const pickerMapConfigAtom: MapUserConfigAtom = atom<MapUserConfig>({
  ...baseMapConfig,
  wellsV2: { ...baseMapConfig.wellsV2, checked: false },
  // `checked: false` alone is not enough — Map renders DevelopmentAreasLayer
  // unconditionally and the layer tests its own options, so they have to be cleared.
  developmentAreas: {
    checked: false,
    options: {
      horizontalUnits: false,
      verticalUnits: false,
      fieldUnits: false,
      pricing: false,
    },
  },
});
